import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Pipe({
  name: 'translate',
  pure: false//so it can listen to language changing events,using any other way wont work
})
export class TranslatePipe implements PipeTransform {

  constructor(private translationService: TranslationService) { }

  transform(labelCode: any, args?: any): any {
    return this.getLabel(labelCode);
  }

  /**
   * Get a label from translationService by the label code and the user locale.
   * 
   * @param labelCode 
   * @return label translation if found otherwise return labelCode
   */
  getLabel(labelCode: string): string {
    let key = "desc" + this.translationService.getPrimaryLang();
    let translations = this.translationService.getTranslations();
    if (translations[labelCode] && translations[labelCode][key]) {
      return translations[labelCode][key];
    }
    return labelCode;
  }

  /**
   * Get a label from translationService by the label code if not found then it will use orLabelCode.
   * @param labelCode 
   * @param orLabelCode 
   * @return the label if exists otherwise uses orLabelCode
   */
  getLabelOr(labelCode: string, orLabelCode: string): string {
    let result: string = this.getLabel(labelCode);
    //if the result is the same as labelCode then the label was not found
    return result !== labelCode ? result : this.getLabel(orLabelCode);
  }

}
